import { WaveRole, type WaveParticipantRecord } from "@vida/wave-core";

function roleLabel(role: WaveRole): string {
  switch (role) {
    case WaveRole.Owner:
      return "Proprietario";
    case WaveRole.Editor:
      return "Editor";
    case WaveRole.Commenter:
      return "Commentatore";
    case WaveRole.Viewer:
      return "Lettore";
    default:
      return role;
  }
}

function participantLabel(p: WaveParticipantRecord): string {
  return (p.displayName ?? p.email ?? p.sub).trim() || p.sub;
}

type Props = {
  participants: WaveParticipantRecord[];
  ownerSub: string;
};

export function WaveParticipantsList({ participants, ownerSub }: Props) {
  if (participants.length === 0) {
    return (
      <p className="wave-participants-empty">
        Nessun partecipante ancora — invita qualcuno o condividi il link.
      </p>
    );
  }

  const sorted = [...participants].sort((a, b) => {
    if (a.sub === ownerSub) return -1;
    if (b.sub === ownerSub) return 1;
    return participantLabel(a).localeCompare(participantLabel(b), "it");
  });

  return (
    <ul className="wave-participants" aria-label="Partecipanti condivisi">
      {sorted.map((p) => (
        <li key={p.sub} className="wave-participant-chip">
          <span className="wave-participant-name">{participantLabel(p)}</span>
          <span className="wave-participant-role">{roleLabel(p.role)}</span>
        </li>
      ))}
    </ul>
  );
}
